import { useMutation } from '@tanstack/react-query';
import createPrivateAdminPanelInstance from '../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../api/ApiRoutes';

const postCreateWithdrawalRule = async (payload) => {
  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.CREATE_WITHDRAWAL_RULE,
    payload
  );
  return response.data;
};

export const useCreateWithdrawalRule = () => {
  return useMutation({
    mutationFn: postCreateWithdrawalRule,
  });
};
